// Auto-generated from sales-codes.csv
// Maps promo codes to sales codes
export const salesCodesMap = new Map([
  ['162677', '20001141'],
  ['162668', '20001141'],
  ['169046', '20001137'],
  ['169047', '20001139'],
  ['169048', '20001139'],
  ['169049', '20001139'],
  ['169050', '20001139'],
  ['169051', '20001139'],
  ['169052', '20001137'],
  ['169053', '20001139'],
  ['169054', '20001139'],
  ['169055', '20001139'],
  ['169056', '20001139'],
  ['169057', '20001139'],
  ['169289', '20001139'],
  ['169290', '20001142'],
  ['169291', '20001142'],
  ['169292', '20001142'],
  ['169293', '20001142'],
  ['169294', '20001139'],
  ['169295', '20001142'],
  ['169296', '20001142'],
  ['169297', '20001142'],
  ['169298', '20001142'],
  ['169343', '20001142'],
  ['169344', '20001142'],
  ['169345', '20001142'],
  ['169349', '20001142'],
  ['169350', '20001142'],
  ['169351', '20001142'],
  ['169323', '20001137'],
  ['169324', '20001139'],
  ['169325', '20001139'],
  ['169326', '20001139'],
  ['169327', '20001139'],
  ['169328', '20001139'],
  ['169329', '20001142'],
  ['169330', '20001142'],
  ['169331', '20001142'],
  ['169332', '20001142'],
  ['169333', '20001137'],
  ['169334', '20001139'],
  ['169335', '20001139'],
  ['169336', '20001139'],
  ['169337', '20001139'],
  ['169338', '20001139'],
  ['169339', '20001142'],
  ['169340', '20001142'],
  ['169341', '20001142'],
  ['169342', '20001142'],
  ['169346', '20001142'],
  ['169347', '20001142'],
  ['169348', '20001142'],
  ['169352', '20001142'],
  ['169353', '20001142'],
  ['169354', '20001142'],
  ['169370', '20001139'],
  ['169371', '20001139'],
  ['162955', '20001137'],
  ['162956', '20001139'],
  ['162957', '20001139'],
  ['162958', '20001139'],
  ['162959', '20001139'],
  ['162960', '20001139'],
  ['162961', '20001142'],
  ['162962', '20001142'],
  ['162963', '20001142'],
  ['162964', '20001142'],
  ['162965', '20001137'],
  ['162966', '20001139'],
  ['162967', '20001139'],
  ['162968', '20001139'],
  ['162969', '20001139'],
  ['162970', '20001139'],
  ['162971', '20001142'],
  ['162972', '20001142'],
  ['162973', '20001142'],
  ['162974', '20001142'],
  ['162975', '20001142'],
  ['162976', '20001142'],
  ['162977', '20001142'],
  ['162978', '20001142'],
  ['162979', '20001142'],
  ['162980', '20001142'],
  ['162981', '20001139'],
  ['162982', '20001139'],
  ['162983', '20001142'],
  ['162984', '20001142'],
  ['162985', '20001139'],
  ['162986', '20001142'],
  ['162841', '20001137'],
  ['169385', '20001139'],
  ['169386', '20001139'],
  ['169387', '20001139'],
  ['169388', '20001139'],
  ['169389', '20001139'],
  ['169390', '20001142'],
  ['169391', '20001142'],
  ['169392', '20001142'],
  ['169393', '20001139'],
  ['169394', '20001139'],
  ['169395', '20001139'],
  ['162843', '20001139'],
  ['169396', '20001139'],
  ['169397', '20001139'],
  ['162842', '20001142'],
  ['162845', '20001137'],
  ['169398', '20001139'],
  ['169399', '20001139'],
  ['169400', '20001139'],
  ['169401', '20001139'],
  ['169402', '20001139'],
  ['169403', '20001142'],
  ['169404', '20001142'],
  ['169405', '20001142'],
  ['169406', '20001139'],
  ['169407', '20001139'],
  ['169408', '20001139'],
  ['162847', '20001139'],
  ['169409', '20001139'],
  ['169410', '20001139'],
  ['162846', '20001142'],
  ['170856', '20001136'],
  ['170857', '20001136'],
  ['170429', '20001141'],
  ['170430', '20001141'],
  ['172090', '20001141'],
  ['172091', '20001141'],
  ['171862', '20001141'],
  ['171863', '20001141'],
  ['168025', '20001138'],
  ['168033', '20001138'],
  ['168026', '20001138'],
  ['168034', '20001138'],
  ['168024', '20001138'],
  ['168032', '20001138'],
  ['162710', '20001142'],
  ['162671', '20001142'],
  ['162662', '20001142'],
  ['162869', '20001142'],
  ['162715', '20001142'],
  ['162884', '20001142'],
  ['162895', '20001142'],
  ['162931', '20001142'],
  ['162812', '20001142'],
  ['162894', '20001142'],
  ['162830', '20001142'],
  ['162885', '20001142'],
  ['162917', '20001142'],
  ['162901', '20001142'],
  ['162915', '20001142'],
  ['162716', '20001142'],
  ['162887', '20001142'],
  ['162916', '20001142'],
  ['162938', '20001142'],
  ['163945', '20001142'],
  ['162813', '20001142'],
  ['162876', '20001142'],
  ['162897', '20001142'],
  ['162907', '20001142'],
  ['162913', '20001142'],
  ['162711', '20001142'],
  ['162918', '20001142'],
  ['162926', '20001142'],
  ['162719', '20001142'],
  ['162875', '20001142'],
  ['162888', '20001142'],
  ['162714', '20001142'],
  ['162828', '20001142'],
  ['162873', '20001142'],
  ['162937', '20001142'],
  ['162908', '20001142'],
  ['162914', '20001142'],
  ['162912', '20001142'],
  ['162928', '20001142'],
  ['162909', '20001142'],
  ['162934', '20001142'],
  ['162921', '20001142'],
  ['162717', '20001142'],
  ['163944', '20001142'],
  ['162893', '20001142'],
  ['162871', '20001142'],
  ['162896', '20001142'],
  ['162936', '20001142'],
  ['165089', '20001142'],
  ['162826', '20001142'],
  ['162892', '20001142'],
  ['162939', '20001142'],
  ['162924', '20001142'],
  ['162880', '20001142'],
  ['162874', '20001142'],
  ['162881', '20001142'],
  ['162882', '20001142'],
  ['162940', '20001142'],
  ['162943', '20001142'],
  ['162690', '20001142'],
  ['162829', '20001142'],
  ['162831', '20001142'],
  ['161931', '20001142'],
  ['162718', '20001142'],
  ['162866', '20001142'],
  ['162878', '20001142'],
  ['162720', '20001142'],
  ['162832', '20001142'],
  ['162877', '20001142'],
  ['162889', '20001142'],
  ['162890', '20001142'],
  ['165090', '20001142'],
  ['162905', '20001142'],
  ['162910', '20001142'],
  ['162919', '20001142'],
  ['162923', '20001142'],
  ['162824', '20001142'],
  ['162870', '20001142'],
  ['162927', '20001142'],
  ['162935', '20001142'],
  ['162809', '20001142'],
  ['162811', '20001142'],
  ['162883', '20001142'],
  ['162721', '20001142'],
  ['162942', '20001142'],
  ['162944', '20001142'],
  ['162902', '20001142'],
  ['162903', '20001142'],
  ['162879', '20001142'],
  ['165087', '20001142'],
  ['162925', '20001142'],
  ['162932', '20001142'],
  ['162825', '20001142'],
  ['162886', '20001142'],
  ['162920', '20001142'],
  ['162930', '20001142'],
  ['162872', '20001142'],
  ['162899', '20001142'],
  ['162900', '20001142'],
  ['165088', '20001142'],
  ['162911', '20001142'],
  ['162929', '20001142'],
  ['162933', '20001142'],
  ['162810', '20001142'],
  ['162922', '20001142'],
  ['162898', '20001142'],
  ['162906', '20001142'],
  ['162891', '20001142'],
  ['162941', '20001142'],
  ['162712', '20001142'],
  ['162867', '20001142'],
  ['172135', '20001145'],
  ['167618', '20001145'],
  ['170533', '20001145'],
  ['160206', '20001145'],
  ['170534', '20001145'],
  ['170532', '20001145'],
  ['160319', '20001145'],
  ['160320', '20001145'],
  ['160321', '20001145'],
  ['160322', '20001145'],
  ['163007', '20001145'],
  ['160323', '20001145'],
  ['160324', '20001145'],
  ['160325', '20001145'],
  ['160326', '20001145'],
])

export const getSalesCode = (promoCode) => {
  if (!promoCode) return null
  return salesCodesMap.get(promoCode) || null
}
